var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"slice-annoucement px-10 lg_px-12 flex flex-wrap justify-between items-center min-h-32 md_min-h-40 py-10 bg-black text-white"},[_vm._v(_vm._s(_vm.slice.primary.text))])}
var staticRenderFns = []

export { render, staticRenderFns }